import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';
import { CompanyDetails } from '../types/CompanyDetails';

export const useGetCompany = (companyID: number | undefined) => {
    const { data, isLoading } = useQuery({
        queryKey: ['company', companyID],
        queryFn: async () => await apiClient.get('company/details', {
            params: {
                companyID: companyID
            }
        }) as CompanyDetails,
        enabled: !!companyID
    });

    return {
        data: data,
        isLoading: isLoading
    };
};
